import React from "react";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  return (
    <nav className="navbar">
      <NavLink
        to="/"
        style={({ isActive }) => {
          return { color: isActive ? "red" : "gray" };
        }}
      >
        Home
      </NavLink>
      <NavLink
        to="/about"
        style={({ isActive }) => {
          return { color: isActive ? "red" : "gray" };
        }}
      >
        About
      </NavLink>
      <NavLink
        to="/products"
        style={({ isActive }) => {
          return { color: isActive ? "red" : "gray" };
        }}
      >
        Products
      </NavLink>
      <NavLink
        to="/contact"
        style={({ isActive }) => {
          return { color: isActive ? "red" : "gray" };
        }}
      >
        Contact
      </NavLink>
      <NavLink
        to="/Login"
        style={({ isActive }) => {
          return { color: isActive ? "red" : "gray" };
        }}
      >
        Login
      </NavLink>
    </nav>
  );
};

export default Navbar;
